<script>
import transformtranslatemenu from './transform-translate-menu'

export default {
  name: 'transformoption',
  components: {
    transformtranslatemenu
  },
  props: {
    optionname: String
  },
  computed: {
    transformoption () {
      return this.$store.getters['transform/getItemByName'](this.optionname)
    },
    isTransformTranslate () {
      return this.transformoption.transformtype === 'translate'
    },    
    label () {
      if (this.transformoption.label) {
        return this.transformoption.label
      } else {
        return ''
      }
    },
  },
  methods: {
  }  
}
</script>

<template>
  <v-list-group
    v-if="transformoption && transformoption.options.length > 1"
    color='accent'
  >
    <template v-slot:activator>
      <v-list-item-avatar 
        v-if="label" 
        class="elevation-4 headline"
        left
      >
        <span class="headline">{{label}}</span>
      </v-list-item-avatar>

      <v-list-item-content two-line>
          <v-list-item-title v-text="transformoption.title"></v-list-item-title>
          <v-list-item-subtitle>{{ transformoption.currentTitle }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <v-divider></v-divider>

    <transformtranslatemenu v-if="isTransformTranslate" :options="transformoption.options" :name="transformoption.name"/>

  </v-list-group>
</template>